export default "__VITE_ASSET__ClT3CA_0__"